import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
    DialogModule,
    DataTableModule
} from 'primeng/primeng';

import { ContactSelectDialogComponent } from './contact-select-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        DialogModule,
        DataTableModule
    ],
    declarations: [
        ContactSelectDialogComponent
    ],
    exports: [
        ContactSelectDialogComponent
    ]
})
export class ContactSelectDialogModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/contact-select-dialog/contact-select-dialog.module.ts